
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import DashboardHeader from "././buserheadepage/DashboardHeader";

import { cancelAppointment } from "../../redux/slices/appointmentsSlice";
import cancelAppointmentFromDb from "../../redux/apis/cancelAppointment";
import { cancelTestFromDb } from "../../redux/apis/cancelTestFromDb";

import DoctorSlotManager from "../availability/DoctorSlotManager";

import axios from "axios";

import {
  FaHome,
  FaUsers,
  FaUserMd,
  FaCalendarCheck,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClock,
  FaCalendarAlt,
} from "react-icons/fa";

import AppointmentsPage from "../Dashboard/AppointmentsPage";

import referTestToLab from "../../redux/apis/Businessuser/testRecommendationThunk";

import { fetchAppointmentsByDoctorId } from "../../redux/apis/Businessuser/appointmentSlice";

import { fetchUsersByCategory } from "../../redux/commonsharing/busercatwise";

import {
  rescheduleAppointment,
  setAppointments,
  updateAppointmentStatus,
  addPrescription,
  testRecommendation,
} from "../../redux/slices/appointmentsSlice";

import { updatedataanasave } from "../../redux/apis/Businessuser/updateDatasaveDb";

import PatientsView from "./PatientsView";
import HomeSummary from "./HomeSummary";

/* ============================================================
   SIDEBAR ITEM
============================================================ */

const SidebarItem = ({
  icon: Icon,
  label,
  active,
  onClick,
}) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }}
    className={`
      group
      relative
      flex
      items-center
      gap-4
      px-4
      py-3
      mx-1
      rounded-xl
      cursor-pointer
      transition-all
      duration-200

      ${
        active
          ? `
            bg-gradient-to-r
            from-[#0f1f33]
            via-[#1a3a5c]
            to-[#1e4976]
            text-white
            shadow-[0_4px_12px_rgba(15,31,51,0.16)]
          `
          : `
            bg-transparent
            text-[#36516c]
            hover:bg-[#eef5fa]
            hover:text-[#0f1f33]
          `
      }
    `}
  >
    <Icon
      className={`
        w-5
        h-5
        flex-shrink-0
        transition-colors
        duration-200

        ${
          active
            ? "text-[#7dd3fc]"
            : "text-[#607991] group-hover:text-[#0ea5e9]"
        }
      `}
    />

    <span
      className={`
        text-sm
        font-semibold
        transition-colors
        duration-200

        ${active ? "text-white" : "text-[#36516c]"}
      `}
    >
      {label}
    </span>

    {active && (
      <span
        className="
          absolute
          right-2
          w-1.5
          h-7
          rounded-full
          bg-[#38bdf8]
        "
      />
    )}
  </div>
);

/* ============================================================
   MAIN COMPONENT
============================================================ */

const BusinessUserDashboard = () => {
  /* ============================================================
     USER + UI STATE
  ============================================================ */

  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  /* ============================================================
     IMAGE MODAL
  ============================================================ */

  const [imageModalOpen, setImageModalOpen] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);

  /* ============================================================
     REGISTERED USERS
  ============================================================ */

  const [registeredUsers, setRegisteredUsers] = useState([]);

  const [showRegisteredUsers, setShowRegisteredUsers] =
    useState(false);

  /* ============================================================
     ACTION STATES
  ============================================================ */

  const [actionLoading, setActionLoading] = useState(false);

  /* ============================================================
     RESCHEDULE
  ============================================================ */

  const [rescheduleModalOpen, setRescheduleModalOpen] =
    useState(false);

  const [selectedAppointmentId, setSelectedAppointmentId] =
    useState(null);

  const [newDate, setNewDate] = useState("");

  const [newTime, setNewTime] = useState("");

  /* ============================================================
     SEARCH
  ============================================================ */

  const [searchQuery, setSearchQuery] = useState("");

  const [professionCategory, setProfessionCategory] =
    useState("All");

  /* ============================================================
     TEST NOTIFICATIONS
  ============================================================ */

  const [notifiedTests, setNotifiedTests] = useState({});

  /* ============================================================
     ACTIVE SECTION
  ============================================================ */

  const [activeSection, setActiveSection] =
    useState("Appointments");

  /* ============================================================
     REDUX
  ============================================================ */

  const {
    isAuthenticated,
    userId,
  } = useSelector((state) => state.auth);

  const loggedInUserId = useSelector(
    (state) => state.auth.userId
  );

  /* ============================================================
     DATE
  ============================================================ */

  const [selectedDate, setSelectedDate] = useState(() => {
    return new Date().toISOString().slice(0, 10);
  });

  /* ============================================================
     EXPANDED DATES
  ============================================================ */

  const [expandedDates, setExpandedDates] = useState({});

  const toggleDateExpand = (date) => {
    setExpandedDates((prev) => ({
      ...prev,
      [date]: !prev[date],
    }));
  };

  /* ============================================================
     CONFIG
  ============================================================ */

  const baseUrl =
    process.env.REACT_APP_BACKEND_BASE_URL;

  /* ============================================================
     OTHER MEDICAL USERS
  ============================================================ */

  const [OtherMedicalUsers, setOtherMedicalUsers] =
    useState({});

  const [searchQueries, setSearchQueries] = useState({});

  /* ============================================================
     NAVIGATION
  ============================================================ */

  const navigate = useNavigate();

  const dispatch = useDispatch();

  /* ============================================================
     VALID USER IDS
  ============================================================ */

  const [validUserIds, setValidUserIds] = useState(new Set());

  /* ============================================================
     SELECTED APPOINTMENT
  ============================================================ */

  const [selectedAppointment, setSelectedAppointment] =
    useState(null);

  const [loadingAppointments, setLoadingAppointments] =
    useState(true);

  /* ============================================================
     FETCH APPOINTMENTS
  ============================================================ */

  useEffect(() => {
    if (!isAuthenticated) {
      console.log(
        "🚫 User not authenticated, redirecting to login"
      );

      navigate("/login");

      return;
    }

    if (!userId) {
      console.log(
        "⚠️ No userId available yet, waiting..."
      );

      return;
    }

    dispatch(fetchAppointmentsByDoctorId(userId))
      .unwrap()
      .catch((err) => {
        console.error("❌ Fetch failed:", err);
      })
      .finally(() => {
        setLoadingAppointments(false);
      });
  }, [
    isAuthenticated,
    userId,
    dispatch,
    navigate,
  ]);

  /* ============================================================
     ALL APPOINTMENTS
  ============================================================ */

  const allAppointments = useSelector((state) => {
    return (
      state.appointmentsfromreduxstore
        ?.allAppointments || []
    );
  });

  /* ============================================================
     FILTER APPOINTMENTS
  ============================================================ */

  const filteredAppointments =
    allAppointments.filter((app) => {
      const appointmentDoctorId =
        app?.doctorInfo?.id ||
        app?.doctorId;

      return (
        String(appointmentDoctorId) ===
        String(userId)
      );
    });

  /* ============================================================
     GROUP BY PATIENT
  ============================================================ */

  const groupedByPatient =
    filteredAppointments.reduce(
      (acc, appt) => {
        const patientId =
          appt.patientInfo?.id;

        if (!patientId) {
          console.warn(
            "⚠️ Missing patient ID:",
            appt
          );

          return acc;
        }

        if (!acc[patientId]) {
          acc[patientId] = {
            patient: appt.patientInfo,
            appointments: [],
          };
        }

        acc[patientId].appointments.push(appt);

        return acc;
      },
      {}
    );

  /* ============================================================
     FETCH BUSINESS PROFILE
  ============================================================ */

  useEffect(() => {
    const authToken =
      localStorage.getItem("token");

    const storedUserId =
      localStorage.getItem("userId");

    if (!authToken || !storedUserId) {
      navigate("/login");
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/business/profile/${storedUserId}`,
          {
            headers: {
              Authorization:
                `Bearer ${authToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            "Failed to fetch user data"
          );
        }

        const data =
          await response.json();

        const {
          password,
          ...filteredData
        } = data;

        setUser(filteredData);
      } catch (err) {
        console.error(
          "❌ Profile fetch error:",
          err
        );

        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate, baseUrl]);

  /* ============================================================
     ADD TEST RECOMMENDATION
  ============================================================ */

  const handleAddTestRecommendation = (
    appointmentId
  ) => {
    const testType = prompt(
      "Enter the test name or type to recommend"
    );

    if (!testType?.trim()) {
      alert(
        "Test type cannot be empty."
      );

      return;
    }

    const doctorDescription =
      prompt(
        "Enter the doctor's description"
      );

    if (!doctorDescription?.trim()) {
      alert(
        "Doctor's description cannot be empty."
      );

      return;
    }

    dispatch(
      testRecommendation({
        id: appointmentId,
        testType: testType.trim(),
        doctorDescription:
          doctorDescription.trim(),
      })
    );

    alert(
      "✅ Test recommendation added successfully."
    );
  };

  /* ============================================================
     CANCEL TEST
  ============================================================ */

  const handleCancelTestRecommendation =
    async (
      appointmentId,
      testId
    ) => {
      try {
        const reason = prompt(
          "Reason for cancelling this test:",
          "User requested"
        );

        if (
          reason === null ||
          reason.trim() === ""
        ) {
          alert(
            "Cancellation reason is required."
          );

          return;
        }

        const confirmCancel =
          window.confirm(
            "Are you sure you want to cancel this test recommendation?"
          );

        if (!confirmCancel) return;

        const result =
          await dispatch(
            cancelTestFromDb({
              appointmentId,
              testId,
              reason: reason.trim(),
            })
          );

        if (
          cancelTestFromDb.fulfilled.match(
            result
          )
        ) {
          alert(
            "✅ Test cancelled successfully."
          );
        } else {
          alert(
            "❌ Failed to cancel test. Please try again."
          );
        }
      } catch (error) {
        console.error(
          "Error cancelling test:",
          error
        );

        const message =
          error.response?.data?.message ||
          error.message ||
          "Failed to cancel test. Please try again.";

        alert(message);
      }
    };

  /* ============================================================
     PRESCRIPTION
  ============================================================ */

  const handleAddPrescription = (
    appointmentId
  ) => {
    const prescription = prompt(
      "Enter the prescription details"
    );

    if (
      prescription &&
      prescription.trim() !== ""
    ) {
      dispatch(
        addPrescription({
          id: appointmentId,
          prescription:
            prescription.trim(),
        })
      );
    } else {
      alert(
        "Prescription cannot be empty."
      );
    }
  };

  /* ============================================================
     STATUS
  ============================================================ */

  const handleStatusChange = (
    appointmentId,
    newStatus
  ) => {
    dispatch(
      updateAppointmentStatus({
        id: appointmentId,
        newStatus,
      })
    );

    alert(
      `Status updated to ${newStatus}`
    );
  };

  /* ============================================================
     FETCH USER IDS
  ============================================================ */

  useEffect(() => {
    const fetchUserIds = async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/users/list`
        );

        const data =
          await res.json();

        const ids = new Set(
          data.map((user) =>
            user._id?.toString()
          )
        );

        setValidUserIds(ids);
      } catch (err) {
        console.error(
          "Failed to load user list:",
          err
        );
      }
    };

    fetchUserIds();
  }, [baseUrl]);

  /* ============================================================
     CANCEL APPOINTMENT
  ============================================================ */

  const handleCancelAppointment =
    async (appointmentId) => {
      const confirmCancel =
        window.confirm(
          "Are you sure you want to cancel this appointment?"
        );

      if (!confirmCancel) return;

      setActionLoading(appointmentId);

      const result =
        await dispatch(
          cancelAppointmentFromDb(
            appointmentId
          )
        );

      if (
        cancelAppointmentFromDb.fulfilled.match(
          result
        )
      ) {
        dispatch(
          cancelAppointment(
            appointmentId
          )
        );

        setAppointments((prev) =>
          prev.filter(
            (data) =>
              data.appointmentId !==
              appointmentId
          )
        );

        setSearchQueries({});
        setOtherMedicalUsers({});
      } else {
        alert(
          "❌ Failed to cancel appointment. Please try again."
        );
      }

      setActionLoading(null);
    };

  /* ============================================================
     RESCHEDULE
  ============================================================ */

  const handleRescheduleSubmit =
    () => {
      const isValidDate =
        /^\d{4}-\d{2}-\d{2}$/.test(
          newDate
        );

      const isValidTime =
        /^([0-1]\d|2[0-3]):([0-5]\d)$/.test(
          newTime
        );

      if (
        !isValidDate ||
        !isValidTime
      ) {
        alert(
          "Invalid date or time format."
        );

        return;
      }

      setActionLoading(true);

      dispatch(
        rescheduleAppointment({
          id: selectedAppointmentId,
          newDate,
          newTime,
        })
      );

      setActionLoading(false);

      setRescheduleModalOpen(false);

      alert(
        "Please press the save button to update"
      );
    };

  /* ============================================================
     REFER TEST
  ============================================================ */

  const handleReferTest = async (
    OtherMedicalUser,
    test,
    appointmentId
  ) => {
    const result =
      await dispatch(
        referTestToLab({
          OtherMedicalUser,
          test,
          appointmentId,
        })
      );

    if (
      referTestToLab.fulfilled.match(
        result
      )
    ) {
      alert(
        "✅ Test referred and saved successfully."
      );
    } else {
      console.error(
        "❌ Failed to refer test:",
        result.payload
      );

      alert(
        `❌ Failed to refer test: ${result.payload}`
      );
    }
  };

  /* ============================================================
     NOTIFY + SAVE TEST
  ============================================================ */

  const handleNotifyAndSave = async ({
    appointmentId,
    testRecommendation,
  }) => {
    if (
      !appointmentId ||
      !testRecommendation
    ) {
      alert(
        "❌ Missing appointment or test info"
      );

      return;
    }

    if (
      !testRecommendation.testid ||
      !testRecommendation.testType
    ) {
      alert(
        "❌ testid and testType are required in the test recommendation"
      );

      return;
    }

    const otherMedicalUser =
      testRecommendation.OtherMedicalUser ||
      (OtherMedicalUsers[
        testRecommendation.testid
      ] ?? null);

    const testWithUser = {
      testid:
        testRecommendation.testid,

      testType:
        testRecommendation.testType,

      notes:
        testRecommendation.notes ||
        "",

      OtherMedicalUser:
        otherMedicalUser,
    };

    try {
      await axios.put(
        `${baseUrl}/appointments/${appointmentId}/test-recommendations`,
        testWithUser
      );

      alert(
        "✅ Test saved successfully."
      );
    } catch (error) {
      console.error(
        "❌ Error saving test:",
        error
      );

      alert(
        `❌ Failed to save test. ${
          error.response?.data?.message ||
          error.message
        }`
      );
    }
  };

  /* ============================================================
     SAVE APPOINTMENT
  ============================================================ */

  const handleSaveToDB = async (
    appt
  ) => {
    const updatedRecommendations =
      appt.testRecommendations.map(
        (test) => {
          const updatedUser =
            OtherMedicalUsers[
              test.testid
            ];

          if (updatedUser) {
            return {
              ...test,

              OtherMedicalUser: {
                _id:
                  updatedUser._id,

                fullName:
                  updatedUser.fullName,

                email:
                  updatedUser.email,

                phone:
                  updatedUser.phone,

                profilePic:
                  updatedUser.profilePic ||
                  "",
              },
            };
          }

          return test;
        }
      );

    const updatedAppointment = {
      ...appt,
      testRecommendations:
        updatedRecommendations,
    };

    const result =
      await dispatch(
        updatedataanasave(
          updatedAppointment
        )
      );

    if (
      updatedataanasave.fulfilled.match(
        result
      )
    ) {
      console.log(
        "✔️ Appointment saved or updated:",
        result.payload
      );
    } else {
      console.error(
        "❌ Failed to save appointment:",
        result.payload
      );
    }
  };

  /* ============================================================
     IMAGE MODAL
  ============================================================ */

  const closeImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage(null);
  };

  /* ============================================================
     LOADING
  ============================================================ */

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        Loading...
      </div>
    );
  }

  /* ============================================================
     ERROR
  ============================================================ */

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen text-red-500">
        Error: {error}
      </div>
    );
  }

  /* ============================================================
     FILTER USERS
  ============================================================ */

  const filteredUsers =
    professionCategory === "All"
      ? registeredUsers
      : registeredUsers.filter(
          (registeredUser) =>
            registeredUser.profession ===
            professionCategory
        );

  /* ============================================================
     UNIQUE CATEGORIES
  ============================================================ */

  const uniqueCategories = [
    "All",
    ...new Set(
      registeredUsers.map(
        (registeredUser) =>
          registeredUser.profession
      )
    ),
  ];

  /* ============================================================
     FETCH REGISTERED USERS
  ============================================================ */

  const fetchRegisteredUsers =
    async (category) => {
      try {
        const resultAction =
          await dispatch(
            fetchUsersByCategory(
              category
            )
          );

        if (
          fetchUsersByCategory.fulfilled.match(
            resultAction
          )
        ) {
          const {
            filteredUsers,
          } =
            resultAction.payload;

          setRegisteredUsers(
            filteredUsers
          );

          setShowRegisteredUsers(
            true
          );
        } else {
          throw new Error(
            resultAction.payload ||
              "Failed to fetch users"
          );
        }
      } catch (err) {
        console.error(
          "Redux Fetch Error:",
          err
        );

        alert(
          err.message ||
            "Error fetching user data"
        );
      }
    };

  /* ============================================================
     NAVIGATION HELPERS
  ============================================================ */

  const openSection = (section) => {
    setActiveSection(section);
    setShowRegisteredUsers(false);
  };

  const openRegisteredUsers = (section) => {
    setActiveSection(section);
    setShowRegisteredUsers(true);
  };

  /* ============================================================
     MAIN UI
  ============================================================ */

  return (
    <div className="flex flex-col min-h-screen bg-[#eef3f8]">

      {/* ========================================================
          HEADER
      ======================================================== */}

      <div className="w-full sticky top-0 z-40">
        <DashboardHeader />
      </div>

      {/* ========================================================
          MAIN LAYOUT
      ======================================================== */}

      <div className="flex flex-1 min-w-0">

        {/* ======================================================
            DESKTOP SIDEBAR
        ====================================================== */}

        <aside
          className="
            hidden md:flex
            w-64 lg:w-64 xl:w-72
            flex-shrink-0
            bg-white
            border-r border-[#d8e3ee]
            shadow-[2px_0_12px_rgba(15,31,51,0.04)]
            flex-col
            sticky
            top-[64px]
            h-[calc(100vh-64px)]
          "
        >

          {/* SIDEBAR HEADER */}

          <div className="px-5 py-5 border-b border-[#e1e8f0]">

            <div
              className="
                rounded-2xl
                p-4
                bg-gradient-to-br
                from-[#0f1f33]
                via-[#1a3a5c]
                to-[#1e4976]
                shadow-[0_5px_18px_rgba(15,31,51,0.16)]
              "
            >
              <p className="text-[10px] uppercase tracking-[0.18em] text-sky-200 font-bold">
                Doctor Dashboard
              </p>

              <h2 className="text-white font-bold text-base mt-1">
                Medical Management
              </h2>

              <p className="text-[11px] text-slate-300 mt-1">
                Manage your practice
              </p>
            </div>

          </div>

          {/* ====================================================
              DESKTOP NAVIGATION
          ==================================================== */}

          <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">

            {/* HOME */}

            <SidebarItem
              icon={FaHome}
              label="Home"
              active={
                activeSection === "Home" &&
                !showRegisteredUsers
              }
              onClick={() =>
                openSection("Home")
              }
            />

            {/* PATIENTS */}

            <SidebarItem
              icon={FaUsers}
              label="Patients"
              active={
                activeSection === "Patients" &&
                !showRegisteredUsers
              }
              onClick={() =>
                openSection("Patients")
              }
            />

            {/* DOCTORS */}

            <SidebarItem
              icon={FaUserMd}
              label="Doctors"
              active={
                activeSection === "Doctors" &&
                showRegisteredUsers
              }
              onClick={() => {
                fetchRegisteredUsers(
                  "Doctors"
                );

                openRegisteredUsers(
                  "Doctors"
                );
              }}
            />

            {/* OTHER MEDICAL SERVICES */}

            <SidebarItem
              icon={FaCalendarCheck}
              label="Other Medical Services"
              active={
                activeSection ===
                  "Other Medical Services" &&
                showRegisteredUsers
              }
              onClick={() => {
                fetchRegisteredUsers(
                  "Other Medical Services"
                );

                openRegisteredUsers(
                  "Other Medical Services"
                );
              }}
            />

            {/* APPOINTMENTS */}

            <SidebarItem
              icon={FaCalendarCheck}
              label="Appointments"
              active={
                activeSection ===
                  "Appointments" &&
                !showRegisteredUsers
              }
              onClick={() =>
                openSection("Appointments")
              }
            />

            {/* ==================================================
                SLOT MANAGEMENT
            ================================================== */}

            <div className="pt-2">

              <SidebarItem
                icon={FaClock}
                label="Slot Management"
                active={
                  activeSection ===
                    "Slot Management" &&
                  !showRegisteredUsers
                }
                onClick={() => {
                  console.log(
                    "⏰ Slot Management clicked"
                  );

                  setActiveSection(
                    "Slot Management"
                  );

                  setShowRegisteredUsers(
                    false
                  );
                }}
              />

            </div>

            {/* DIVIDER */}

            <div className="py-3">
              <div className="border-t border-[#e5edf4]" />
            </div>

          </nav>

          {/* ====================================================
              SIDEBAR FOOTER
          ==================================================== */}

          <div className="p-4 border-t border-[#e1e8f0]">

            <div
              className="
                flex
                items-center
                gap-3
                px-3
                py-3
                rounded-xl
                bg-[#f4f8fb]
              "
            >

              <div
                className="
                  w-9
                  h-9
                  rounded-full
                  bg-gradient-to-br
                  from-[#1a3a5c]
                  to-[#0ea5e9]
                  flex
                  items-center
                  justify-center
                  text-white
                  shadow-sm
                "
              >
                <FaUserMd className="text-sm" />
              </div>

              <div className="min-w-0">

                <p className="text-xs font-bold text-[#193a5c] truncate">
                  Medical Portal
                </p>

                <p className="text-[10px] text-[#8093a7] truncate">
                  Secure Dashboard
                </p>

              </div>

            </div>

          </div>

        </aside>

        {/* ======================================================
            MOBILE NAVIGATION
        ====================================================== */}

        <div
          className="
            md:hidden
            fixed
            bottom-0
            left-0
            right-0
            z-50
            bg-white
            border-t border-[#d8e3ee]
            shadow-[0_-4px_18px_rgba(15,31,51,0.10)]
          "
        >

          <div className="grid grid-cols-6 h-[68px]">

            {/* HOME */}

            <button
              type="button"
              onClick={() =>
                openSection("Home")
              }
              className={`
                relative
                flex
                flex-col
                items-center
                justify-center
                gap-1
                transition-all
                duration-200

                ${
                  activeSection ===
                    "Home" &&
                  !showRegisteredUsers
                    ? `
                      bg-gradient-to-br
                      from-[#0f1f33]
                      via-[#1a3a5c]
                      to-[#1e4976]
                      text-white
                    `
                    : `
                      text-[#1a3a5c]
                      hover:bg-[#f5f8fb]
                    `
                }
              `}
            >
              <FaHome
                className={`
                  text-base
                  ${
                    activeSection ===
                      "Home" &&
                    !showRegisteredUsers
                      ? "text-[#7dd3fc]"
                      : "text-[#1a3a5c]"
                  }
                `}
              />

              <span className="text-[9px] font-semibold">
                Home
              </span>

              {activeSection ===
                "Home" &&
                !showRegisteredUsers && (
                  <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-[#38bdf8]" />
                )}
            </button>

            {/* PATIENTS */}

            <button
              type="button"
              onClick={() =>
                openSection("Patients")
              }
              className={`
                relative
                flex
                flex-col
                items-center
                justify-center
                gap-1
                transition-all
                duration-200

                ${
                  activeSection ===
                    "Patients" &&
                  !showRegisteredUsers
                    ? `
                      bg-gradient-to-br
                      from-[#0f1f33]
                      via-[#1a3a5c]
                      to-[#1e4976]
                      text-white
                    `
                    : `
                      text-[#1a3a5c]
                      hover:bg-[#f5f8fb]
                    `
                }
              `}
            >
              <FaUsers
                className={`
                  text-base
                  ${
                    activeSection ===
                      "Patients" &&
                    !showRegisteredUsers
                      ? "text-[#7dd3fc]"
                      : "text-[#1a3a5c]"
                  }
                `}
              />

              <span className="text-[9px] font-semibold">
                Patients
              </span>

              {activeSection ===
                "Patients" &&
                !showRegisteredUsers && (
                  <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-[#38bdf8]" />
                )}
            </button>

            {/* DOCTORS */}

            <button
              type="button"
              onClick={() => {
                fetchRegisteredUsers(
                  "Doctors"
                );

                openRegisteredUsers(
                  "Doctors"
                );
              }}
              className={`
                relative
                flex
                flex-col
                items-center
                justify-center
                gap-1
                transition-all
                duration-200

                ${
                  activeSection ===
                    "Doctors" &&
                  showRegisteredUsers
                    ? `
                      bg-gradient-to-br
                      from-[#0f1f33]
                      via-[#1a3a5c]
                      to-[#1e4976]
                      text-white
                    `
                    : `
                      text-[#1a3a5c]
                      hover:bg-[#f5f8fb]
                    `
                }
              `}
            >
              <FaUserMd
                className={`
                  text-base
                  ${
                    activeSection ===
                      "Doctors" &&
                    showRegisteredUsers
                      ? "text-[#7dd3fc]"
                      : "text-[#1a3a5c]"
                  }
                `}
              />

              <span className="text-[9px] font-semibold">
                Doctors
              </span>

              {activeSection ===
                "Doctors" &&
                showRegisteredUsers && (
                  <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-[#38bdf8]" />
                )}
            </button>

            {/* SERVICES */}

            <button
              type="button"
              onClick={() => {
                fetchRegisteredUsers(
                  "Other Medical Services"
                );

                openRegisteredUsers(
                  "Other Medical Services"
                );
              }}
              className={`
                relative
                flex
                flex-col
                items-center
                justify-center
                gap-1
                transition-all
                duration-200

                ${
                  activeSection ===
                    "Other Medical Services" &&
                  showRegisteredUsers
                    ? `
                      bg-gradient-to-br
                      from-[#0f1f33]
                      via-[#1a3a5c]
                      to-[#1e4976]
                      text-white
                    `
                    : `
                      text-[#1a3a5c]
                      hover:bg-[#f5f8fb]
                    `
                }
              `}
            >
              <FaCalendarCheck
                className={`
                  text-base
                  ${
                    activeSection ===
                      "Other Medical Services" &&
                    showRegisteredUsers
                      ? "text-[#7dd3fc]"
                      : "text-[#1a3a5c]"
                  }
                `}
              />

              <span className="text-[9px] font-semibold">
                Services
              </span>

              {activeSection ===
                "Other Medical Services" &&
                showRegisteredUsers && (
                  <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-[#38bdf8]" />
                )}
            </button>

            {/* APPOINTMENTS */}

            <button
              type="button"
              onClick={() =>
                openSection("Appointments")
              }
              className={`
                relative
                flex
                flex-col
                items-center
                justify-center
                gap-1
                transition-all
                duration-200

                ${
                  activeSection ===
                    "Appointments" &&
                  !showRegisteredUsers
                    ? `
                      bg-gradient-to-br
                      from-[#0f1f33]
                      via-[#1a3a5c]
                      to-[#1e4976]
                      text-white
                    `
                    : `
                      text-[#1a3a5c]
                      hover:bg-[#f5f8fb]
                    `
                }
              `}
            >
              <FaCalendarCheck
                className={`
                  text-base
                  ${
                    activeSection ===
                      "Appointments" &&
                    !showRegisteredUsers
                      ? "text-[#7dd3fc]"
                      : "text-[#1a3a5c]"
                  }
                `}
              />

              <span className="text-[9px] font-semibold">
                Appointments
              </span>

              {activeSection ===
                "Appointments" &&
                !showRegisteredUsers && (
                  <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-[#38bdf8]" />
                )}
            </button>

            {/* SLOT MANAGEMENT */}

            <button
              type="button"
              onClick={() => {
                console.log(
                  "⏰ Mobile Slot Management clicked"
                );

                openSection(
                  "Slot Management"
                );
              }}
              className={`
                relative
                flex
                flex-col
                items-center
                justify-center
                gap-1
                transition-all
                duration-200

                ${
                  activeSection ===
                    "Slot Management" &&
                  !showRegisteredUsers
                    ? `
                      bg-gradient-to-br
                      from-[#0f1f33]
                      via-[#1a3a5c]
                      to-[#1e4976]
                      text-white
                    `
                    : `
                      text-[#1a3a5c]
                      hover:bg-[#f5f8fb]
                    `
                }
              `}
            >
              <FaClock
                className={`
                  text-base
                  ${
                    activeSection ===
                      "Slot Management" &&
                    !showRegisteredUsers
                      ? "text-[#7dd3fc]"
                      : "text-[#1a3a5c]"
                  }
                `}
              />

              <span className="text-[9px] font-semibold">
                Slots
              </span>

              {activeSection ===
                "Slot Management" &&
                !showRegisteredUsers && (
                  <span className="absolute bottom-0 w-8 h-0.5 rounded-full bg-[#38bdf8]" />
                )}
            </button>

          </div>
        </div>

        {/* ======================================================
            MAIN CONTENT
        ====================================================== */}

        <main className="flex-1 min-w-0 pb-20 md:pb-0">

          {/* ====================================================
              REGISTERED USERS
          ==================================================== */}

          {showRegisteredUsers && (
            <section className="w-full px-3 py-4 sm:px-5 sm:py-5 md:px-6 lg:px-8">

              {/* PAGE HEADER */}

              <div
                className="
                  rounded-2xl
                  bg-gradient-to-br
                  from-[#0f1f33]
                  via-[#1a3a5c]
                  to-[#1e4976]
                  px-4
                  py-5
                  sm:px-6
                  sm:py-6
                  shadow-[0_6px_22px_rgba(15,31,51,0.14)]
                  mb-5
                "
              >

                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

                  <div className="min-w-0">

                    <p className="text-[10px] uppercase tracking-[0.18em] text-sky-200 font-bold">
                      Medical Network
                    </p>

                    <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mt-1 truncate">
                      {activeSection}
                    </h1>

                    <p className="text-xs sm:text-sm text-slate-300 mt-1">
                      View and manage registered medical professionals
                    </p>

                  </div>

                  <div
                    className="
                      self-start
                      sm:self-auto
                      px-3
                      py-2
                      rounded-xl
                      bg-white/10
                      border border-white/10
                      backdrop-blur-sm
                      flex-shrink-0
                    "
                  >

                    <p className="text-[10px] uppercase tracking-wide text-sky-200 font-bold">
                      Registered
                    </p>

                    <p className="text-xl font-bold text-white">
                      {filteredUsers?.length || 0}
                    </p>

                  </div>

                </div>

              </div>

              {/* FILTER */}

              <div
                className="
                  bg-white
                  border border-[#d8e3ee]
                  rounded-2xl
                  p-4
                  sm:p-5
                  shadow-[0_2px_10px_rgba(15,31,51,0.04)]
                  mb-5
                "
              >

                <div className="flex flex-col sm:flex-row sm:items-end gap-3 sm:gap-4">

                  <div className="flex-1 max-w-xl">

                    <label
                      className="
                        block
                        mb-2
                        text-[10px]
                        uppercase
                        tracking-[0.12em]
                        font-bold
                        text-[#5d7590]
                      "
                    >
                      Filter by Profession
                    </label>

                    <select
                      className="
                        w-full
                        px-3.5
                        py-2.5
                        bg-[#f8fafc]
                        border border-[#ccd9e6]
                        rounded-xl
                        text-sm
                        text-[#26425e]
                        font-medium
                        outline-none
                        transition
                        focus:bg-white
                        focus:border-[#0ea5e9]
                        focus:ring-4
                        focus:ring-sky-100
                      "
                      value={professionCategory}
                      onChange={(e) =>
                        setProfessionCategory(
                          e.target.value
                        )
                      }
                    >

                      {uniqueCategories.map(
                        (professionCat) => (
                          <option
                            key={professionCat}
                            value={professionCat}
                          >
                            {professionCat}
                          </option>
                        )
                      )}

                    </select>

                  </div>

                </div>

              </div>

              {/* USERS GRID */}

              {filteredUsers?.length > 0 ? (
                <div
                  className="
                    grid
                    grid-cols-1
                    sm:grid-cols-2
                    lg:grid-cols-2
                    xl:grid-cols-3
                    2xl:grid-cols-4
                    gap-4
                  "
                >

                  {filteredUsers.map(
                    (registeredUser) => {

                      const isYou =
                        String(
                          registeredUser?._id
                        ) ===
                        String(
                          loggedInUserId
                        );

                      return (
                        <div
                          key={registeredUser._id}
                          className={`
                            relative
                            bg-white
                            rounded-2xl
                            overflow-hidden
                            border
                            ${
                              isYou
                                ? "border-[#0ea5e9]"
                                : "border-[#d8e3ee]"
                            }
                            shadow-[0_2px_10px_rgba(15,31,51,0.05)]
                            hover:shadow-[0_6px_20px_rgba(15,31,51,0.10)]
                            hover:-translate-y-0.5
                            transition-all
                            duration-200
                          `}
                        >

                          <div
                            className="
                              h-1.5
                              bg-gradient-to-r
                              from-[#0f1f33]
                              via-[#1a3a5c]
                              to-[#0ea5e9]
                            "
                          />

                          <div className="p-4 sm:p-5">

                            <div className="flex items-start gap-3">

                              <div className="flex-shrink-0">

                                {registeredUser.profilePicUrl ? (
                                  <img
                                    src={
                                      registeredUser.profilePicUrl
                                    }
                                    alt={
                                      registeredUser.fullName ||
                                      "Profile"
                                    }
                                    className="
                                      w-12
                                      h-12
                                      sm:w-14
                                      sm:h-14
                                      rounded-full
                                      object-cover
                                      border-2
                                      border-[#e1ebf4]
                                      shadow-sm
                                    "
                                    onError={(
                                      e
                                    ) => {
                                      e.currentTarget.style.display =
                                        "none";
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="
                                      w-12
                                      h-12
                                      sm:w-14
                                      sm:h-14
                                      rounded-full
                                      bg-gradient-to-br
                                      from-[#1a3a5c]
                                      to-[#0ea5e9]
                                      text-white
                                      flex
                                      items-center
                                      justify-center
                                      font-bold
                                      text-base
                                      shadow-sm
                                    "
                                  >
                                    {registeredUser.fullName
                                      ?.charAt(0)
                                      ?.toUpperCase() ||
                                      "U"}
                                  </div>
                                )}

                              </div>

                              <div className="min-w-0 flex-1">

                                <div className="flex items-start justify-between gap-2">

                                  <h3
                                    className="
                                      text-sm
                                      sm:text-base
                                      font-bold
                                      text-[#102a45]
                                      leading-tight
                                      truncate
                                    "
                                  >
                                    {registeredUser.fullName ||
                                      "Unknown User"}
                                  </h3>

                                  {isYou && (
                                    <span
                                      className="
                                        flex-shrink-0
                                        inline-flex
                                        items-center
                                        px-2
                                        py-1
                                        rounded-full
                                        bg-[#eef5fa]
                                        text-[#0ea5e9]
                                        text-[9px]
                                        font-bold
                                      "
                                    >
                                      ● You
                                    </span>
                                  )}

                                </div>

                                <p
                                  className="
                                    text-[10px]
                                    uppercase
                                    tracking-wide
                                    font-semibold
                                    text-[#8194a8]
                                    mt-1
                                  "
                                >
                                  {registeredUser.profession ||
                                    "Medical Professional"}
                                </p>

                              </div>

                            </div>

                            <div className="border-t border-[#edf1f5] my-4" />

                            <div className="space-y-2.5">

                              {/* EMAIL */}

                              <div className="flex items-start gap-2">

                                <div
                                  className="
                                    w-7
                                    h-7
                                    flex-shrink-0
                                    rounded-lg
                                    bg-[#eef5fa]
                                    flex
                                    items-center
                                    justify-center
                                  "
                                >
                                  <FaEnvelope className="text-xs text-[#1a3a5c]" />
                                </div>

                                <div className="min-w-0">

                                  <p className="text-[9px] uppercase tracking-wide font-bold text-[#91a1b1]">
                                    Email
                                  </p>

                                  <p className="text-xs text-[#36516c] truncate">
                                    {registeredUser.email ||
                                      "Not available"}
                                  </p>

                                </div>

                              </div>

                              {/* PHONE */}

                              <div className="flex items-start gap-2">

                                <div
                                  className="
                                    w-7
                                    h-7
                                    flex-shrink-0
                                    rounded-lg
                                    bg-[#eef5fa]
                                    flex
                                    items-center
                                    justify-center
                                  "
                                >
                                  <FaPhoneAlt className="text-xs text-[#1a3a5c]" />
                                </div>

                                <div className="min-w-0">

                                  <p className="text-[9px] uppercase tracking-wide font-bold text-[#91a1b1]">
                                    Phone
                                  </p>

                                  <p className="text-xs text-[#36516c]">
                                    {registeredUser.phone ||
                                      "Not available"}
                                  </p>

                                </div>

                              </div>

                              {/* PROFESSION */}

                              <div className="flex items-start gap-2">

                                <div
                                  className="
                                    w-7
                                    h-7
                                    flex-shrink-0
                                    rounded-lg
                                    bg-[#eef5fa]
                                    flex
                                    items-center
                                    justify-center
                                  "
                                >
                                  <FaUserMd className="text-xs text-[#1a3a5c]" />
                                </div>

                                <div className="min-w-0">

                                  <p className="text-[9px] uppercase tracking-wide font-bold text-[#91a1b1]">
                                    Profession
                                  </p>

                                  <p className="text-xs text-[#36516c]">
                                    {registeredUser.profession ||
                                      "Not available"}
                                  </p>

                                </div>

                              </div>

                              {/* LOCATION */}

                              <div className="flex items-start gap-2">

                                <div
                                  className="
                                    w-7
                                    h-7
                                    flex-shrink-0
                                    rounded-lg
                                    bg-[#eef5fa]
                                    flex
                                    items-center
                                    justify-center
                                  "
                                >
                                  <FaMapMarkerAlt className="text-xs text-[#1a3a5c]" />
                                </div>

                                <div className="min-w-0">

                                  <p className="text-[9px] uppercase tracking-wide font-bold text-[#91a1b1]">
                                    Location
                                  </p>

                                  <p className="text-xs text-[#36516c] leading-relaxed">

                                    {[
                                      registeredUser.city,
                                      registeredUser.state,
                                      registeredUser.country,
                                    ]
                                      .filter(Boolean)
                                      .join(", ") ||
                                      "Location unavailable"}

                                    {registeredUser.postalCode && (
                                      <span className="text-[#71869d]">
                                        {" "}
                                        -{" "}
                                        {
                                          registeredUser.postalCode
                                        }
                                      </span>
                                    )}

                                  </p>

                                </div>

                              </div>

                            </div>

                            <div className="mt-4 pt-3 border-t border-[#edf1f5]">

                              <div
                                className="
                                  flex
                                  items-center
                                  justify-between
                                  text-[10px]
                                  text-[#8194a8]
                                "
                              >

                                <span>
                                  Medical Network
                                </span>

                                <span
                                  className="
                                    inline-flex
                                    items-center
                                    gap-1
                                    text-[#0ea5e9]
                                    font-semibold
                                  "
                                >

                                  <span
                                    className="
                                      w-1.5
                                      h-1.5
                                      rounded-full
                                      bg-[#0ea5e9]
                                    "
                                  />

                                  Registered

                                </span>

                              </div>

                            </div>

                          </div>

                        </div>
                      );
                    }
                  )}

                </div>
              ) : (

                <div
                  className="
                    bg-white
                    border border-[#d8e3ee]
                    rounded-2xl
                    py-16
                    px-5
                    text-center
                    shadow-[0_2px_10px_rgba(15,31,51,0.04)]
                  "
                >

                  <div
                    className="
                      w-14
                      h-14
                      mx-auto
                      rounded-2xl
                      bg-[#eef5fa]
                      flex
                      items-center
                      justify-center
                    "
                  >
                    <FaUsers className="text-[#1a3a5c] text-xl" />
                  </div>

                  <h3 className="mt-4 text-base font-bold text-[#27425d]">
                    No users found
                  </h3>

                  <p className="text-xs sm:text-sm text-[#8193a6] mt-1">
                    No registered users are available for this profession.
                  </p>

                </div>
              )}

            </section>
          )}

          {/* ====================================================
              HOME
          ==================================================== */}

          {activeSection === "Home" &&
            !showRegisteredUsers && (
              <div className="w-full">

                <HomeSummary
                  filteredAppointments={
                    filteredAppointments
                  }
                />

              </div>
            )}

          {/* ====================================================
              PATIENTS
          ==================================================== */}

          {activeSection === "Patients" &&
            !showRegisteredUsers && (
              <div className="w-full">

                <PatientsView
                  groupedByPatient={
                    groupedByPatient
                  }
                />

              </div>
            )}

          {/* ====================================================
              APPOINTMENTS
          ==================================================== */}

          {activeSection ===
            "Appointments" &&
            !showRegisteredUsers && (
              <div className="w-full">

                <AppointmentsPage
                  groupedByPatient={
                    groupedByPatient
                  }

                  expandedDates={
                    expandedDates
                  }

                  toggleDateExpand={
                    toggleDateExpand
                  }

                  baseUrl={baseUrl}

                  otherMedicalUsers={
                    OtherMedicalUsers
                  }

                  setOtherMedicalUsers={
                    setOtherMedicalUsers
                  }

                  searchQueries={
                    searchQueries
                  }

                  setSearchQueries={
                    setSearchQueries
                  }

                  notifiedTests={
                    notifiedTests
                  }

                  setNotifiedTests={
                    setNotifiedTests
                  }

                  registeredUsers={
                    registeredUsers
                  }

                  handleNotifyAndSave={
                    handleNotifyAndSave
                  }

                  handleCancelTestRecommendation={
                    handleCancelTestRecommendation
                  }

                  handleAddPrescription={
                    handleAddPrescription
                  }

                  handleStatusChange={
                    handleStatusChange
                  }

                  handleCancelAppointment={
                    handleCancelAppointment
                  }

                  handleAddTestRecommendation={
                    handleAddTestRecommendation
                  }

                  handleSaveToDB={
                    handleSaveToDB
                  }

                  fetchRegisteredUsers={
                    fetchRegisteredUsers
                  }
                />

              </div>
            )}

          {/* ====================================================
              SLOT MANAGEMENT
          ==================================================== */}

          {activeSection ===
            "Slot Management" &&
            !showRegisteredUsers && (
              <div className="w-full min-w-0">

                <DoctorSlotManager />

              </div>
            )}

        </main>

        {/* ======================================================
            IMAGE MODAL
        ====================================================== */}

        {imageModalOpen && (
          <div
            className="
              fixed
              inset-0
              z-[100]
              bg-[#0f1f33]/75
              backdrop-blur-sm
              flex
              items-center
              justify-center
              p-3
              sm:p-5
            "
            onClick={closeImageModal}
          >

            <div
              className="
                relative
                bg-white
                rounded-2xl
                shadow-2xl
                p-3
                sm:p-4
                max-w-4xl
                w-full
                max-h-[90vh]
                overflow-hidden
              "
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              <button
                onClick={
                  closeImageModal
                }
                className="
                  absolute
                  top-2
                  right-2
                  z-10
                  w-9
                  h-9
                  rounded-full
                  bg-gradient-to-r
                  from-[#1a3a5c]
                  to-[#0ea5e9]
                  hover:opacity-90
                  text-white
                  text-xl
                  flex
                  items-center
                  justify-center
                  shadow-lg
                  transition
                "
              >
                &times;
              </button>

              <div className="flex items-center justify-center bg-[#f4f7fa] rounded-xl p-2">

                <img
                  src={selectedImage}
                  alt="Profile"
                  className="
                    max-w-full
                    max-h-[78vh]
                    object-contain
                    rounded-lg
                  "
                />

              </div>

            </div>

          </div>
        )}

        {/* ======================================================
            RESCHEDULE MODAL
        ====================================================== */}

        {rescheduleModalOpen &&
          selectedAppointment && (
            <div
              className="
                fixed
                inset-0
                z-[100]
                bg-[#0f1f33]/70
                backdrop-blur-sm
                flex
                items-center
                justify-center
                p-3
                sm:p-5
              "
            >

              <div
                className="
                  bg-white
                  w-full
                  max-w-md
                  rounded-2xl
                  shadow-2xl
                  overflow-hidden
                  max-h-[92vh]
                  overflow-y-auto
                "
              >

                {/* MODAL HEADER */}

                <div
                  className="
                    px-5
                    py-4
                    sm:px-6
                    sm:py-5
                    bg-gradient-to-br
                    from-[#0f1f33]
                    via-[#1a3a5c]
                    to-[#1e4976]
                  "
                >

                  <div className="flex items-center justify-between gap-3">

                    <div>

                      <p className="text-[10px] uppercase tracking-[0.14em] text-sky-200 font-bold">
                        Appointment
                      </p>

                      <h3 className="text-lg sm:text-xl font-bold text-white mt-1">
                        Reschedule Appointment
                      </h3>

                    </div>

                    <button
                      onClick={() =>
                        setRescheduleModalOpen(
                          false
                        )
                      }
                      className="
                        w-8
                        h-8
                        rounded-full
                        bg-white/10
                        hover:bg-white/20
                        text-white
                        flex
                        items-center
                        justify-center
                        transition
                      "
                    >
                      &times;
                    </button>

                  </div>

                </div>

                <div className="p-4 sm:p-6">

                  {/* CURRENT SCHEDULE */}

                  <div
                    className="
                      mb-5
                      rounded-xl
                      bg-[#f4f8fb]
                      border border-[#dce6ef]
                      p-4
                    "
                  >

                    <p className="text-[10px] uppercase tracking-wide font-bold text-[#8194a8] mb-3">
                      Current Schedule
                    </p>

                    <div className="space-y-2.5">

                      {/* DATE */}

                      <div className="flex items-start gap-3">

                        <div
                          className="
                            w-8
                            h-8
                            rounded-lg
                            bg-[#eef5fa]
                            flex
                            items-center
                            justify-center
                            flex-shrink-0
                          "
                        >
                          <FaCalendarAlt className="text-sm text-[#1a3a5c]" />
                        </div>

                        <div>

                          <p className="text-[10px] uppercase tracking-wide font-bold text-[#8a9bab]">
                            Date
                          </p>

                          <p className="text-sm font-semibold text-[#263f59]">

                            <span className="line-through text-[#8a9bab] mr-2">

                              {new Date(
                                selectedAppointment.previousDate ||
                                  selectedAppointment.date
                              )
                                .toISOString()
                                .slice(0, 10)}

                            </span>

                            <span className="text-[#0ea5e9]">

                              {new Date(
                                selectedAppointment.date
                              )
                                .toISOString()
                                .slice(0, 10)}

                            </span>

                          </p>

                        </div>

                      </div>

                      {/* TIME */}

                      <div className="flex items-start gap-3">

                        <div
                          className="
                            w-8
                            h-8
                            rounded-lg
                            bg-[#eef5fa]
                            flex
                            items-center
                            justify-center
                            flex-shrink-0
                          "
                        >
                          <FaClock className="text-sm text-[#1a3a5c]" />
                        </div>

                        <div>

                          <p className="text-[10px] uppercase tracking-wide font-bold text-[#8a9bab]">
                            Time
                          </p>

                          <p className="text-sm font-semibold text-[#263f59]">

                            <span className="line-through text-[#8a9bab] mr-2">

                              {selectedAppointment.previousTime ||
                                selectedAppointment.time}

                            </span>

                            <span className="text-[#0ea5e9]">

                              {
                                selectedAppointment.time
                              }

                            </span>

                          </p>

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* NEW DATE */}

                  <div className="mb-4">

                    <label
                      className="
                        block
                        mb-2
                        text-[10px]
                        uppercase
                        tracking-wide
                        font-bold
                        text-[#5d7590]
                      "
                    >
                      New Date
                    </label>

                    <div className="relative">

                      <FaCalendarAlt
                        className="
                          absolute
                          left-3
                          top-1/2
                          -translate-y-1/2
                          text-[#1a3a5c]
                          pointer-events-none
                        "
                      />

                      <input
                        type="date"
                        value={newDate}
                        onChange={(e) =>
                          setNewDate(
                            e.target.value
                          )
                        }
                        className="
                          w-full
                          pl-10
                          pr-3.5
                          py-3
                          bg-[#f8fafc]
                          border border-[#ccd9e6]
                          rounded-xl
                          text-sm
                          text-[#26425e]
                          outline-none
                          focus:bg-white
                          focus:border-[#0ea5e9]
                          focus:ring-4
                          focus:ring-sky-100
                          transition
                        "
                      />

                    </div>

                  </div>

                  {/* NEW TIME */}

                  <div className="mb-6">

                    <label
                      className="
                        block
                        mb-2
                        text-[10px]
                        uppercase
                        tracking-wide
                        font-bold
                        text-[#5d7590]
                      "
                    >
                      New Time
                    </label>

                    <div className="relative">

                      <FaClock
                        className="
                          absolute
                          left-3
                          top-1/2
                          -translate-y-1/2
                          text-[#1a3a5c]
                          pointer-events-none
                        "
                      />

                      <input
                        type="time"
                        value={newTime}
                        onChange={(e) =>
                          setNewTime(
                            e.target.value
                          )
                        }
                        className="
                          w-full
                          pl-10
                          pr-3.5
                          py-3
                          bg-[#f8fafc]
                          border border-[#ccd9e6]
                          rounded-xl
                          text-sm
                          text-[#26425e]
                          outline-none
                          focus:bg-white
                          focus:border-[#0ea5e9]
                          focus:ring-4
                          focus:ring-sky-100
                          transition
                        "
                      />

                    </div>

                  </div>

                  {/* ACTIONS */}

                  <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">

                    <button
                      onClick={() =>
                        setRescheduleModalOpen(
                          false
                        )
                      }
                      className="
                        w-full
                        sm:w-auto
                        px-5
                        py-2.5
                        rounded-xl
                        bg-[#edf2f6]
                        hover:bg-[#e1e8ee]
                        text-[#38536d]
                        text-sm
                        font-semibold
                        transition
                      "
                    >
                      Close
                    </button>

                    <button
                      onClick={
                        handleRescheduleSubmit
                      }
                      className="
                        w-full
                        sm:w-auto
                        px-5
                        py-2.5
                        rounded-xl
                        bg-gradient-to-r
                        from-[#1a3a5c]
                        to-[#0ea5e9]
                        hover:opacity-95
                        text-white
                        text-sm
                        font-semibold
                        shadow-[0_4px_12px_rgba(14,165,233,0.20)]
                        transition
                      "
                    >
                      Submit
                    </button>

                  </div>

                </div>

              </div>

            </div>
          )}

      </div>
    </div>
  );
};

export default BusinessUserDashboard;
